import { render, staticRenderFns } from "./SpinnerFlex.vue?vue&type=template&id=f9825d90"
import script from "./SpinnerFlex.vue?vue&type=script&lang=js"
export * from "./SpinnerFlex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports